import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';

export interface SummaryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientSummary {
    id?: any;
    regId: any;
    issueDate: any;
    summaryId: any;
    admissionId?:any;
    visitId:any;
    physicianId:any;
    summaryDets?: SummaryDet;
    params?: any;
    summaryResult?: string;
    createdBy:any;
    createdDate:any;
    tenantId: any;
    branchId: any;

    parameters?: SummaryParameter[];
    links?: any;
}

export interface SummaryMst {
    summaryId?: any;
    summaryTitle: string;
    summaryDescription: string;
    summaryType: string;
    tenantId: any;
    branchId: any;
    summaryDetailMsts?: SummaryDet[];
    
}

export interface SummaryDet {
    fieldId: any;
    summaryId: any;
    summaryFields? : SummaryFields
}

export interface SummaryFields {
    fieldId: any;
    fieldName: any;
    columnName?: string;
    tblName?: string;
    dataType?:string;
    fieldType?:string;
    defaultFieldValue?:string;
}


export abstract class SummaryData {
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<any[]>;
    abstract get_patient_summary(url: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any>;
    //abstract bulkUpdate(url: string, data: CertificateMst[]): Observable<CertificateMst>;
    abstract update(url: string, data: SummaryMst): Observable<SummaryMst>;
    abstract update_patient_summary(url: string, data: any): Observable<SummaryMst>;
    abstract delete(url: string): Observable<any>;
    abstract delete_summary(url: string): Observable<any>;
    
}